import { useSelector } from 'react-redux';
import type { RootState } from '../../store/store';
import { Navigate } from 'react-router-dom';

export const FeatureComponent = ({ feature, children }: { feature: string; children: React.ReactNode }) => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to='/login' replace />;
  }

  // Check if user has the required feature
  if (!user?.features.includes(feature)) {
    return <Navigate to='/' replace />;
  }

  return children;
};
